import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false
};

const authDialogSlice = createSlice({
  name: 'authDialog',
  initialState,
  reducers: {
    openDialog: state => {
      state.isOpen = true;
    },
    closeDialog: state => {
      state.isOpen = false;
    }
  }
});

export const { openDialog, closeDialog } = authDialogSlice.actions;

export default authDialogSlice.reducer;
